import * as React from 'react';
import { Provider } from 'mobx-react';
import { PermissionsStore } from './stores';
import { Permissions } from './Permissions';

export interface IProps {
  environment: "Development" | "Test" | "Production";
  token: string;
  tenant: string;
  highlightColor: string;
  marginTop: number;
}

export class IAPermissions extends React.Component<IProps> {

  private permissionsStore: PermissionsStore;

  constructor(props: IProps) {
    super(props);
    this.permissionsStore = new PermissionsStore();
    this.permissionsStore.environment = props.environment;
    this.permissionsStore.token = props.token;
    this.permissionsStore.tenant = props.tenant;
    this.permissionsStore.highlightColor = props.highlightColor;
    this.permissionsStore.marginTop = props.marginTop;
  }

  public componentWillReceiveProps(props: IProps) {
    if (props != this.props) {
      this.permissionsStore.environment = props.environment;
      this.permissionsStore.token = props.token;
      this.permissionsStore.tenant = props.tenant;
      this.permissionsStore.highlightColor = props.highlightColor;
      this.permissionsStore.marginTop = props.marginTop;
    }
  }

  render() {
    return (
      <Provider permissionsStore={this.permissionsStore}>
        <Permissions />
      </Provider>
    )
  }
}